import React, { useEffect, useState } from "react";
import { Page } from "@/components/Layout";
import { api } from "@/lib/api";
import { CalendarBlank, MapPin, ArrowUpRight } from "@phosphor-icons/react";
import Seo from "@/components/Seo";
import { useCurrency } from "@/lib/currency";

export default function Events() {
  const { format } = useCurrency();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => { api.get("/events", { params: filter ? { division: filter } : {} }).then((r) => setItems(r.data)); }, [filter]);
  const fmtDate = (d) => {
    const dt = new Date(`${d}T00:00:00`);
    if (Number.isNaN(dt.getTime())) return d;
    return dt.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  };
  return (
    <Page>
      <Seo title="Events & Workshops" description="Upcoming MindDhara events, webinars and workshops on mental wellbeing, cognitive health and psychology careers." />
      <section className="md-section md-page-hero" data-testid="events-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Events</div>
          <h1 className="text-5xl md:text-6xl font-serif mb-6">Webinars, workshops, in-person</h1>
        </div>
      </section>
      <section className="md-section pt-0">
        <div className="md-container">
          <div className="flex justify-center gap-2 mb-10">
            {["", "couch", "forward"].map((f) => (
              <button key={f || "all"} onClick={() => setFilter(f)} className={`md-tag ${filter === f ? "md-tag-active" : ""}`} data-testid={`events-filter-${f || "all"}`}>{f ? f.charAt(0).toUpperCase() + f.slice(1) : "All"}</button>
            ))}
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((e) => (
              <div key={e.id} className="md-card md-card-hover overflow-hidden" data-testid={`event-card-${e.id}`}>
                {e.cover_url && <img src={e.cover_url} alt={e.title} className="w-full h-44 object-cover rounded-lg -mt-2 -mx-2 mb-4" style={{ width: "calc(100% + 1rem)" }} />}
                <div className="flex items-center gap-2 mb-2">
                  <span className="md-tag text-[10px]" style={{ textTransform: "capitalize" }}>{e.division}</span>
                  <span className="md-tag text-[10px]">{e.mode}</span>
                  <span className="md-tag text-[10px]">{e.is_paid ? format(e.price) : "Free"}</span>
                </div>
                <h3 className="font-serif text-xl">{e.title}</h3>
                <p className="text-sm mt-2" style={{ color: "var(--md-text-soft)" }}>{e.description}</p>
                <div className="flex items-center gap-3 mt-4 text-xs" style={{ color: "var(--md-text-muted)" }}>
                  <span data-testid={`event-when-${e.id}`}><CalendarBlank size={14} className="inline mr-1" />{fmtDate(e.date)}{e.time ? ` · ${e.time}` : ""}</span>
                  <span><MapPin size={14} className="inline mr-1" />{e.location}</span>
                </div>
                {e.is_paid && e.eventbrite_url ? (
                  <a href={e.eventbrite_url} target="_blank" rel="noreferrer" className="btn-accent mt-5 text-sm" data-testid={`event-register-${e.id}`}>Register on Eventbrite <ArrowUpRight size={14} weight="bold" /></a>
                ) : (
                  <button className="btn-primary mt-5 text-sm" data-testid={`event-rsvp-${e.id}`}>RSVP (Free)</button>
                )}
              </div>
            ))}
            {items.length === 0 && <p className="col-span-3 text-center py-10" style={{ color: "var(--md-text-muted)" }}>No events yet.</p>}
          </div>
        </div>
      </section>
    </Page>
  );
}
